const SET_CLIENTE_LOGADO = (state, logado) => {
  state.logado = logado
}

export {
  SET_CLIENTE_LOGADO
}



// WEBPACK FOOTER //
// ./src/store/cliente/mutations.js